export default {
  // Options.jsx
  items_per_page: '/ Seite',
  jump_to: 'Gehe zu',
  jump_to_confirm: 'bestÃ¤tigen',
  page: '',

  // Pagination.jsx
  prev_page: 'Vorherige Seite',
  next_page: 'NÃ¤chste Seite',
  prev_5: '5 Seiten zurÃ¼ck',
  next_5: '5 Seiten vor',
  prev_3: '3 Seiten zurÃ¼ck',
  next_3: '3 Seiten vor',
};
